import React, {useEffect,useState} from "react";
import "./OffRegal.scss";
import SwiperId from "react-id-swiper";
import {useHistory} from "react-router-dom";
import {
    getCats_api,
    getMallCats_api,
    getProductsCategory_api, getProductsCategoryWithTag_api,
    getProductsMall_api,
    getSampleProduct_api
} from "../Services/apis.js";
import {getOffProducts_api} from "../Services/apis";

let merchantRegal = ""
let catRegal = ""

const imageParamss = {
    slidesPerView: 'auto',
    spaceBetween: 50,
    rtl:true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    }
}


const catParams = {
    slidesPerView: 'auto',
    spaceBetween: 10,
    rtl:true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    }
}


function numberWithCommas  (x) {
    if (x === 0) {
        return 0
    }
    if(x){
        return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
    }

    return "-"

}

function limitText(txt,length) {
    if(txt.length>length){
        return txt.substr(0,length)+" ... "
    }else {
        return txt
    }
}

function OffRegal({item}) {
    //hooks
    const history = useHistory();

    const [data,setData] = useState([])
    const [cats,setCats] = useState([])
    const [currentCat,set_currentCat] = useState(null)
    const [color,setColor] = useState("#f5f5f5")

    useEffect( ()=>{
        getProductsMall()
    },[])

    // const selectCat = (c)=>{
    //     set_currentCat(c)
    //     getCatProducts(c.uid)
    //     if(c.name)
    //         item.title = c.name
    // }

    // const getCatProducts = async (cId)=>{
    //     try{
    //         let split = item.items[0].text.split("@")
    //         //set for more product
    //         merchantRegal = split[1]
    //         catRegal = cId
    //         const res = await getProductsCategory_api(split[1],cId)
    //         let proData = {data:res}
    //         setData(proData.data.results)
    //         if(item.items[0].link_to_uid)
    //             setColor(item.items[0].link_to_uid)
    //     }catch (e) {
    //         console.log(e)
    //     }
    //
    // }

    const getProductsMall = async ()=>{
        if(item.items[0].text){
            try{
                let mallId = item.items[0].text;
                const res = await getOffProducts_api(mallId)
                let proData = {data:res}
                setData(proData.data.results)
                if(item.items[0].link_to_uid)
                    setColor(item.items[0].link_to_uid)
            }catch(e){
                console.log(e)
            }
        }
    }

    // const getCats = async(mId,pId)=>{
    //     try{
    //          const res = await getCats_api(mId,pId)
    //         let proData = {data:res}
    //         setCats(proData.data)
    //     }catch (e) {
    //         console.log(e)
    //     }
    // }


    const seeMoreProduct = ()=>{

        history.push(`/online-store-sub-categories/${merchantRegal}/${catRegal}`)
    }

    return(
        // <span>swiper ...</span>
        <div style={{margin: "20px 16px 0 16px"}}>

            {/*{cats && cats.length>0?*/}
            {/*<SwiperId {...catParams}>*/}
            {/*    {cats.map(d=>{*/}
            {/*        return(*/}
            {/*            <div className="swiper-card-container cat-slide" style={currentCat?.uid===d.uid?{backgroundColor:"#096dd9",color:"white"}:{backgroundColor:"white",color:"black"}} onClick={e=>{*/}
            {/*                selectCat(d)*/}
            {/*            }}>*/}
            {/*                <span>{d.name}</span>*/}
            {/*            </div>*/}
            {/*        )*/}
            {/*    })}*/}

            {/*</SwiperId>:null}*/}

            <div className="online-off-section" style={{
                backgroundColor: color,
                margin: "10px 0",
                padding: 8,
            }}>
                {data && data.length>0? <SwiperId {...imageParamss}>
                    <div className="swiper-card-container product-cardi" style={{backgroundColor:color}}>
                        <div className="swiper-card-body">
                                <span>{item.title?item.title:"تخفیفات ویژه"}</span>
                        </div>
                    </div>
                    {data.map(i=>{
                        return(
                            <div style={{width:100}}>
                                <div className="swiper-card-container" onClick={()=>{
                                    let split = item.items[0].text.split("@")
                                    history.push(`/online-store-product/${split[1]}/${i.uid}`)
                                }}>
                                    <div className="swiper-card-body" >
                                        {/*<BasketAddRemove i={i}/>*/}
                                        <div>
                                            <img src={i.image?i.image:"/other/skeleton/product.jpg"} alt=""/>
                                        </div>
                                    </div>
                                    <div className="price-section">
                                        <div className="price">
                                            {numberWithCommas(i.price)} ریال
                                        </div>
                                        {i.price_original-i.price>0?<div className="price-without-off">
                                            {numberWithCommas(i.price_original)}
                                        </div>:null}
                                    </div>
                                    {/*{i && i.discount_percentage!==0?*/}
                                    {/*    <div className="off">*/}
                                    {/*        <span>{i.discount_percentage+" % "}</span>*/}
                                    {/*    </div>:null*/}
                                    {/*}*/}
                                    <div className="info-section">
                                        <div className="name">{limitText(i.name,25)}</div>
                                        {/*<div className="weight">1500 گرمی میهن</div>*/}
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                    <div className="swiper-card-container product-cardi" style={{backgroundColor:color}}>
                        <div className="swiper-card-body">
                            <div className="swiper-more-card">
                                <span>مشاهده محصولات </span>
                                <span onClick={seeMoreProduct} className="swiper-more-card-btn">بیشتر</span>
                            </div>
                        </div>
                    </div>
                    <div className="swiper-card-container product-cardi" style={{backgroundColor:color}}>
                        <div className="swiper-card-body">
                            <span></span>
                        </div>
                    </div>
                </SwiperId>:null}
            </div>
        </div>

    )
}

export {OffRegal};
